export default {
  /**
   *
   * @param state
   * @param counts
   */
  setStaffDashboardDailyAttendanceCount(state, counts) {
    state.counts = counts;
  },
};
